import styled from "styled-components";

export const MediaWidget = styled.article`
  border-radius: 15px;
  border: ${({ theme }) => `1px solid ${theme.colors.campaignMediaAssets.mediaWidgetBorderColor}`};
  background: ${({ theme }) => `${theme.colors.campaignMediaAssets.mediaWidgetBgColor}`};
  padding: 10px;
  font-size: 12px;
`;

export const Header = styled.header`
  padding: 7px;
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  line-height: normal;
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.colors.campaignMediaAssets.mediaWidgetHeaderBorderColor}`};
`;
